import { useTranslation } from 'react-i18next';

import { Button } from '../../UI';
import { useNavigate } from 'react-router';

const BlockedChat = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="relative flex justify-center items-center h-full">
      <img className="absolute top-0" alt="blocked" src="/blocked-chat.jpg" />
      <div className="p-8 bg-primary z-10 text-center mx-8 rounded-xl">
        <p className="font-bold text-lg">{t('chatroom.blocked.title')}</p>
        <p className="pt-2">{t('chatroom.blocked.desc')}</p>
        <Button
          variant="tertiary"
          buttonClass="mt-6 py-2"
          onClick={() => {
            navigate('/contacts');
          }}
        >
          {t('chatroom.blocked.contact')}
        </Button>
      </div>
    </div>
  );
};

export default BlockedChat;
